module.exports = __webpack_public_path__ + "img/p2.90631b6f.gif";